if (!customElements.get('after-four-reviews')) {
  class AfterFourReviews extends HTMLElement {}
  customElements.define('after-four-reviews', AfterFourReviews)
}

(() => {
  const SELECTORS = {
    reviewCard: '.jdgm-carousel-item, .jdgm-cards-carousel__card, [data-review-id], .jdgm-rev',
    next: '.jdgm-carousel__right-arrow, .jdgm-cards-carousel__next, [aria-label*="next" i]'
  };

  const init = (section) => {
    if (section.dataset.afReviewsReady === 'true') return;
    section.dataset.afReviewsReady = 'true';

    const carousel = section.querySelector('[data-af-reviews-carousel]');
    const cards = section.querySelector('[data-af-reviews-cards]');
    const empty = section.querySelector('[data-af-reviews-empty]');
    const dialog = section.querySelector('[data-af-reviews-dialog]');
    const widget = section.querySelector('[data-af-reviews-widget]');
    const openers = [...section.querySelectorAll('[data-af-reviews-open]')];
    const closeButton = section.querySelector('[data-af-reviews-close]');
    let lastFocused = null;

    const hasPublishedReviews = () => Boolean(cards?.querySelector(SELECTORS.reviewCard));
    const syncState = () => {
      const hasReviews = hasPublishedReviews();
      carousel?.toggleAttribute('hidden', !hasReviews);
      empty?.toggleAttribute('hidden', hasReviews);
      section.classList.toggle('has-reviews', hasReviews);
      return hasReviews;
    };

    const openDialog = () => {
      if (!dialog) return;
      lastFocused = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('af-review-dialog-open');
      window.requestAnimationFrame(() => closeButton?.focus());
    };

    const closeDialog = () => {
      if (!dialog?.open) return;
      dialog.close();
      document.documentElement.classList.remove('af-review-dialog-open');
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
    };

    openers.forEach((button) => button.addEventListener('click', openDialog));
    closeButton?.addEventListener('click', closeDialog);
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    const observer = new MutationObserver(syncState);
    if (cards) observer.observe(cards, { childList: true, subtree: true });
    if (widget) observer.observe(widget, { childList: true, subtree: true });

    syncState();
    window.setTimeout(syncState, 1200);
  };

  const initAll = () => document.querySelectorAll('[data-af-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
